import { briqpayCheckoutApi } from './checkout'

export const briqpayApi = {
  checkout: briqpayCheckoutApi
}
